module.exports = __webpack_public_path__ + "static/media/ListViewOffIcon.2390d768.svg";